export default "__VITE_ASSET___kOn88vV__"